import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { Company, Employment, Owner } from '@funnels/types';

export const filterCompanyOwnersOnChaneEmployment = (
  linkedRelatedCompany: Company | undefined,
  applicantId: string,
  employment: Employment
): Owner[] | undefined => {
  const formValues = { companies: [linkedRelatedCompany], employments: [employment] };
  const type = get(formValues, FIELD_PATHS.EMPLOYMENT_TYPE(0));
  const employmentCompanyId = get(formValues, FIELD_PATHS.EMPLOYMENT_COMPANY_CLIENT_ID(0));
  const companyId = get(formValues, FIELD_PATHS.COMPANY_CLIENT_ID(0));
  const employmentType = get(formValues, FIELD_PATHS.EMPLOYMENT_EMPLOYMENT_TYPE(0));

  if (
    employmentCompanyId !== companyId ||
    employmentType !== FIELD_VALUES.SELF_EMPLOYED ||
    type === FIELD_VALUES.PREVIOUS
  ) {
    return;
  }

  const previousCompanyOwners: Owner[] = get(formValues, FIELD_PATHS.COMPANY_OWNERS(0));
  return previousCompanyOwners?.filter((owner) => owner.applicantId !== applicantId);
};
